import { IImageElement } from '@faire/web-api--source/indigofair/data/IImageElement';
import { IResponsiveTextElement } from '@faire/web-api--source/indigofair/data/IResponsiveTextElement';
import { ITextElement } from '@faire/web-api--source/indigofair/data/ITextElement';

export namespace IImageFanTile {
  export namespace IImageFanTileStyle {
    /**
     * Return an instance of IImageFanTileStyle with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IImageFanTileStyle>
    ): IImageFanTileStyle =>
      ({
        animation_on_hover: [],
        ...(partial ?? {}),
      }) as IImageFanTileStyle;
  }

  /**
   * The tags are out of order. All tag numbers must be unique. When adding fields, also update the field below and the tag number.
   * See https://www.notion.so/faire/Protocol-Buffers-Protos-ba527d2f70c34ab983b8d0417c6a56ac#6a792ceb9d37498795a117e712b9e7e7 for details.
   * The last tag added was `responsivePrimaryText`. The next tag number is 6.
   */
  export interface IImageFanTileStyle {
    animation_on_hover: Array<keyof typeof IImageFanTile.ImageFanTileAnimation>;
    variant: keyof typeof IImageFanTile.ImageFanTileVariant | undefined;
  }

  export enum ImageFanTileAnimation {
    IMAGE_FAN_TILE_ANIMATION_UNKNOWN = 'IMAGE_FAN_TILE_ANIMATION_UNKNOWN',
    HIGHLIGHT_BORDER = 'HIGHLIGHT_BORDER',
    FAN_OUT_IMAGES = 'FAN_OUT_IMAGES',
  }

  export enum ImageFanTileVariant {
    IMAGE_FAN_TILE_VARIANT_UNKNOWN = 'IMAGE_FAN_TILE_VARIANT_UNKNOWN',
    SHORTCUTS = 'SHORTCUTS',
    NAVIGATION = 'NAVIGATION',
  }

  /**
   * Return an instance of IImageFanTile with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IImageFanTile>): IImageFanTile =>
    ({
      image_elements: [],
      ...(partial ?? {}),
    }) as IImageFanTile;
}

export interface IImageFanTile {
  /**
   * @deprecated
   */
  primary_text: ITextElement | undefined;
  responsive_primary_text: IResponsiveTextElement | undefined;
  /**
   * appears below the `primaryText`
   */
  subtitle_text: ITextElement | undefined;
  image_elements: Array<IImageElement>;
  image_fan_tile_style: IImageFanTile.IImageFanTileStyle | undefined;
}
